import React, { useEffect, useState } from "react";
import Filter from "../Consulta/components/Filter";
import Scroll from "../../../components/InfiniteScroll/Scroll";
import Table from "../../../components/Table/Table";
import { columns } from "./constants";
import { withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import {
  findAllExameDasa,
  findAllProcedimentosDasa,
  findResultadoDasaHowPDFByExameDasaId,
} from "../../../services/ExamesService";
import { observer } from "mobx-react-lite";
import { getProfissionalSaudeLogado } from "../../../services/UsuarioService";
import Notification from "../../../components/Notification";
import AddDocumentIcon from "../../../components/Icon/AddCocumentIcon";
import ModalExames from "./ModalExames";
import ModalSelecionarExame from "./ModalSelecionarExame";

export const notificationDefault = {
  open: false,
  message: "",
  variant: "",
};

const pageableDto = {
  sortDir: "ASC",
  sortField: "dataCriacao",
  pageSize: 30,
};

const Exames = observer(
  ({ classes, sujeitoAtencaoStore, unidadeStore, exameStore, history }) => {
    const [search, setSearch] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [exames, setExames] = useState([]);
    const [base64Pdf, setBase64Pdf] = useState(null);
    const [last, setLast] = useState(false);
    const [notification, setNotification] = useState(notificationDefault);
    const [agendamento, setAgendamento] = useState(null);
    const [pageNumber, setPagenumber] = useState(0);
    const [examesProcedimentos, setExamesProcedimentos] = useState(false);

    useEffect(() => {
      inicializeExameDasa()
    }, []);

    useEffect(() => {
      if (sujeitoAtencaoStore?.objView?.id) {
        findAllExames({ resetValues: true });
      }
      if (
        !unidadeStore.configuracaoUnidade &&
        !unidadeStore.isLoadingConfiguracaoUnidade
      ) {
        unidadeStore.inicializaConfiguracaoUnidade();
      }
    }, [sujeitoAtencaoStore?.objView?.id]);

    const findAllExames = async (resetValues) => {
      try {
        if (isLoading) return;

        setIsLoading(true);

        const variables = {
          sujeitoAtencao: {
            id: sujeitoAtencaoStore?.objView?.id,
          },
          pageable: {
            ...pageableDto,
            pageNumber: resetValues ? 0 : pageNumber,
          },
          ...(search && { search }),
        };

        const { content, last } = await findAllExameDasa(variables);

        setExames((prev) => (resetValues ? content : [...prev, ...content]));
        setLast(last);

        const page = resetValues ? 0 : pageNumber + 1;
        setPagenumber(page + 1);
      } catch (error) {
        showAlertMessage({
          isOpen: true,
          message: "Erro ao carregar exames!",
          variant: "error",
        });
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };

    const inicializeExameDasa = async () => {
      if (history?.location?.agendamento) {
        const { agendamento } = history?.location
        const procedimentos = await findProcedimentos(agendamento)
        if (procedimentos?.length > 0) {
          if (procedimentos?.length === 1) {
            exameStore.changeDadosExame(procedimentos[0]?.exameDasaTipo, "tipoExame");
            exameStore.changeDadosExame(
              agendamento?.profissionalSaude,
              "profissionalSolicitante"
            );
            exameStore.changeDadosColeta({
              ...exameStore.dadosColeta,
              sujeitoAtencaoId:
                agendamento?.sujeitoAtencao?.id,
            });
            exameStore.openModalExames = true;
          } else {
            setExamesProcedimentos(procedimentos);
            setAgendamento(agendamento);
            exameStore.openModalSelecionarExame = true;
          }
        }
      }
    } 

    const findProcedimentos = async (objView) => {
      try {
        const response = await findAllProcedimentosDasa({agendamentoId:objView?.id})
        return response;
      } catch (error) {
        console.error(error);
      }
    };

    const handleFilterChange = (e) => {
      setSearch(e);
    };

    const ExportPdf = async () => {
      try {
        const blob = new Blob([base64Pdf], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = "Exame.pdf";
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error(error);
      }
    };

    const onClickExportPdf = async (e) => {
      try {
        const variables = {
          assinatura: true,
          entidadeId: unidadeStore?.configuracaoUnidade?.dadosDasa?.entidade,
          logo: true,
          ordemServico: e?.solicitacoesDasa[0]?.idAlvaro,
        };

        const response = await findResultadoDasaHowPDFByExameDasaId(variables);

        setBase64Pdf(response);

        if (response) {
          await ExportPdf(response);
        }
      } catch (error) {
        showAlertMessage({
          isOpen: true,
          message: "Erro ao baixar Pdf!",
          variant: "error",
        });
      }
    };

    const closeAlertMessage = () => {
      const notification = {
        isOpen: false,
        message: "",
      };
      setNotification({ notification });
    };

    const showAlertMessage = (notification) => {
      setNotification({ notification });

      const timeoutId = setTimeout(() => {
        closeAlertMessage();
        clearTimeout(timeoutId);
      }, 3000);
    };

    const onclickAdicionarExame = async () => {
      const profissionalSaude = await getProfissionalSaudeLogado();
      const sujeitoAtencaoId = sujeitoAtencaoStore?.objView?.id;

      const dadosColetaFormated = {
        sujeitoAtencaoId: sujeitoAtencaoId,
        profissionalSaudeId: profissionalSaude?.id,
      };

      await exameStore.changeDadosColeta(dadosColetaFormated);
      exameStore.togleOpenModalExames();
    };

    return (
      <div className={classes.wrapper}>
        <Filter
          onClickFilterButton={() => findAllExames({ resetValues: true })}
          onChange={handleFilterChange}
          filter={{ search: search }}
          handleApplyFilter={() => findAllExames({ resetValues: true })}
          isLoading={isLoading}
          secondaryButton={{
            label: "Incluir exame",
            icon: <AddDocumentIcon />,
            onClick: () => onclickAdicionarExame(),
          }}
          label={"pesquisar"}
        />
        <Scroll
          classes={{ root: classes.rootScroll }}
          hasMore={!last}
          pageStart={0}
          initialLoad={false}
          loadMore={() => findAllExames()}
        >
          <Table
            dados={exames}
            columns={columns({
              handleClickExportPdf: onClickExportPdf,
            })}
            classes={{
              table: classes.table,
              tableHead: classes.tableHeader,
              tabela: classes.rootTable,
            }}
            emptyMessage={"Nenhum exame encontrado"}
            isLoading={isLoading}
          />
        </Scroll>
        {exameStore.openModalExames && (
          <ModalExames
            open={exameStore.openModalExames}
            onClose={() => exameStore.togleOpenModalExames()}
            findAllExameDasa={findAllExames}
          />
        )}
        {exameStore.openModalSelecionarExame && (
          <ModalSelecionarExame
            open={exameStore.openModalSelecionarExame}
            onClose={() => exameStore.togleOpenModalSelecionarExame()}
            exames={examesProcedimentos}
            agendamento={agendamento}
          />
        )}
        <Notification
          close={closeAlertMessage}
          reset={closeAlertMessage}
          isOpen={notification.open}
          variant={notification.variant}
          message={notification.message}
        />
      </div>
    );
  }
);

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    background: "#f2f2f2",
    padding: "10px",
  },
  rootScroll: {
    height: "calc(100vh - 258px)",
    background: "#fff",
    borderRadius: "20px",
  },
  table: {
    padding: "5px",
    overflow: "scroll",
    "& thead tr th:first-child": {
      borderRadius: "16px 0px 0px 0px",
    },
    "& thead tr th:last-child": {
      borderRadius: "0px 0px 16px 0px ",
    },
  },
  circularProgress: {
    display: "flex",
    width: "100%",
    alignContent: "center",
    justifyContent: "center",
    height: "100%",
    paddingTop: "20px",
  },
};

const stores = [
  "sujeitoAtencaoStore",
  "documentoStore",
  "prontuarioStore",
  "unidadeStore",
  "exameStore",
];
const ExamesWithStyles = withStyles(styles)(Exames);
export default inject(...stores)(ExamesWithStyles);
